/*
Name: carousel.js
Author: Shane Waters
Last Update: 09/04/2018
Description: Banner/Carousel used for CI sites. See http://kenwheeler.github.io/slick/ for more information.

Example usage:
<div class=".home-slideshow-slick">
  <div><img src="img.jpg"></div>
</div>
*/


$(document).ready(function(){

  /*
  Slick carousel settings for header banner slider.
  */
  if($('.home-slideshow-slick').length) {
    var originalWidth = $('.home-slideshow-slick').width();
    var fade = false;

    if($('.home-slideshow-slick').hasClass('fade')) {
      fade = true;
    }

    $('.home-slideshow-slick').slick({
      infinite: true,
      autoplay: true,
      swipe: false,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      autoplaySpeed: 3000,
      speed: 800,
      fade: fade,
      lazyLoad: 'ondemand'
    });


    $('.home-slideshow-slick').find('img').each(function(){
      $(this).width(1170);
    });

    $(window).resize(function(){
      if($(window).width() < 1180) {
        $('.home-slideshow-slick').width($(window).width() - 25);
      } else {
        $('.home-slideshow-slick').width(originalWidth);
      }
    }).resize();
  }
});
